// Formatting shared by the checklist run views.

/** "12m 03s", "45s", "1h 04m"; null when it never started. */
export function duration(from: string | null, to: string | null): string | null {
  if (!from) return null;
  const secs = Math.max(0, Math.round(((to ? new Date(to).getTime() : Date.now()) - new Date(from).getTime()) / 1000));
  if (secs < 60) return `${secs}s`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ${String(secs % 60).padStart(2, '0')}s`;
  return `${Math.floor(mins / 60)}h ${String(mins % 60).padStart(2, '0')}m`;
}

/** "Oct 5, 10:02 AM" */
export const dateTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—';

/** "Oct 5, 2026"; a bare YYYY-MM-DD is read as that calendar day, not UTC midnight. */
export function day(iso: string | null | undefined): string {
  const d = iso ? new Date(/^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso}T12:00:00` : iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
}

export const runMode = (options: { updates?: boolean } | null | undefined) => (options?.updates === false ? 'Check only' : 'With updates');

export const host = (url: string) => url.replace(/^https?:\/\//i, '').replace(/\/$/, '');

export function bytes(n: unknown): string | null {
  if (typeof n !== 'number' || !Number.isFinite(n)) return null;
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v >= 100 || i === 0 ? Math.round(v) : v.toFixed(1)} ${units[i]}`;
}
